import client from '../config/axios';

const fetchCitiesByCountryCode = async (countryCode) => {
  try {
    const response = await client.get(`/geonames/cities/${countryCode}`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener ciudades:', error);
    throw error;
  }
};

export default fetchCitiesByCountryCode;
